<ng-container>
    <div class="create-newsticker-button-container">
        <button class="create-newsticker-button" (click)="createNewstickerPage()">Create Newsticker</button>
    </div>

    <div *ngIf="newstickerList" class="table-container">
        <table mat-table [dataSource]="newstickerList" class="mat-elevation-z8 table">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let item" title="{{item.name}}">{{item.name}}</td>
            </ng-container>

            <ng-container matColumnDef="types">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let item" title="{{item.type | pascalcase}}">{{item.type | pascalcase}}</td>
            </ng-container>

            <ng-container matColumnDef="text">
                <th mat-header-cell *matHeaderCellDef>Text</th>
                <td mat-cell *matCellDef="let item" title="{{item.text['en-us']}}">{{item.text['en-us']}}</td>
            </ng-container>

            <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef>State</th>
                <td
                    mat-cell
                    *matCellDef="let item"
                    title="{{item.status | getEnumKeyFromValue: PublishStatus | pascalcase}}"
                >
                    {{item.status | getEnumKeyFromValue: PublishStatus | pascalcase}}
                </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let item;">
                    <div class="col align-center">
                        <button
                            class="action-button"
                            [disabled]="item.status !== PublishStatus.UNPUBLISHED"
                            (click)="editNewsticker(item)"
                        >
                            Edit
                        </button>

                        <button
                            class="action-button"
                            [disabled]="shouldDisableAllPublishButtons"
                            (click)="setStatus(item, PublishStatus.PUBLISHED)"
                        >
                            Publish
                        </button>

                        <button
                            class="action-button"
                            [disabled]="item.status !== PublishStatus.PUBLISHED"
                            (click)="setStatus(item, PublishStatus.UNPUBLISHED)"
                        >
                            Unpublish
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</ng-container>
